import { Card, Grid } from "@mui/material";
import { AppWidgetSummary } from "src/sections/@dashboard/app";
import UsersSignupChart from "../users/UsersSignupChart";

const STATS = [
	{
		title: "Total IAP",
		field: "totalProfit",
		color: "primary",
		format: "currency",
	},
	{
		title: "Paying Users",
		field: "payUserPct",
		color: "primary",
		format: "percent",
	},
	{
		title: "This month",
		field: "thisMonthProfit",
		color: "secondary",
		format: "currency",
	},
	{
		title: "Last month",
		field: "lastMonthProfit",
		color: "secondary",
		format: "currency",
	},
	{
		title: "This Week",
		field: "thisWeekProfit",
		color: "warning",
		format: "currency",
	},
	{
		title: "Last Week",
		field: "lastWeekProfit",
		color: "warning",
		format: "currency",
	},
	{
		title: "Today",
		field: "todayProfit",
		color: "info",
		format: "currency",
	},
	{
		title: "Yesterday",
		field: "yesterdayProfit",
		color: "info",
		format: "currency",
	},
	{
		title: "Paying Users (1+ Units)",
		field: "totalPayUsers",
		color: "success",
		format: "shorten",
	},
	{
		title: "Avg Rev/ Paying user",
		field: "avgProfitPerPayUser",
		color: "success",
		format: "shortencurrency",
	},
	{
		title: "Avg Rev per all users",
		field: "avgProfitPerAllUsers",
		color: "success",
		format: "shortencurrency",
	},
	{
		title: "Units / Paying users",
		field: "avgPruchasePerUser",
		color: "success",
		format: "shorten",
	},
	{
		title: "One-time buyers (1 Unit)",
		field: "oneTimePayPct",
		color: "success",
		format: "percent",
	},
	{
		title: "Recurring buyers (1+ Units)",
		field: "multipleTimePayPct",
		color: "success",
		format: "percent",
	},
];
export default function MarketplaceStats(props) {
	return (
		<Card sx={{ p: 2, mb: 5 }}>
			<Grid container sx={{ mb: 2 }} spacing={1}>
				<Grid item xs={12} md={8} lg={8}>
					<UsersSignupChart
						title="Revenue Per Day"
						subheader=""
						height={280}
						chartLabels={props.stats.profitPerDay.map((date) => date.date)}
						chartData={[
							{
								name: "Revenue ($)",
								type: "column",
								fill: "solid",
								data: props.stats.profitPerDay.map((date) => date.profit),
							},
						]}
					/>
				</Grid>
				<Grid item xs={12} md={4} lg={4}>
					<Grid container spacing={1}>
						{STATS.slice(0, 8).map((item, index) => (
							<Grid item xs={6} key={index}>
								<AppWidgetSummary
									title={item.title}
									total={props.stats[item.field]}
									icon={"eva:behance-outline"}
									color={item.color}
									format={item.format}
								/>
							</Grid>
						))}
					</Grid>
				</Grid>
				{STATS.slice(8, STATS.length).map((item, index) => (
					<Grid item xs={6} md={2} lg={2} key={index}>
						<AppWidgetSummary
							title={item.title}
							total={props.stats[item.field]}
							icon={"eva:behance-outline"}
							color={item.color}
							format={item.format}
						/>
					</Grid>
				))}
			</Grid>
		</Card>
	);
}
